// import { useEffect, useRef, useState } from "react";

// export default function SlidesPager({ slides = [], onFinish }) {
//   const [idx, setIdx] = useState(0);
//   const [dir, setDir] = useState("right"); // right/left
//   const touchStart = useRef(null);

//   const next = () => (idx < slides.length - 1 ? (setDir("right"), setIdx(i => i+1)) : onFinish?.());
//   const prev = () => (idx > 0 ? (setDir("left"), setIdx(i => i-1)) : null);

//   useEffect(() => {
//     const onKey = (e) => { if (e.key === "ArrowRight") next(); if (e.key === "ArrowLeft") prev(); };
//     window.addEventListener("keydown", onKey); return () => window.removeEventListener("keydown", onKey);
//   }, [idx, slides.length]);

//   const onTouchStart = e => touchStart.current = e.changedTouches[0].clientX;
//   const onTouchEnd = e => {
//     const s = touchStart.current; if (s == null) return;
//     const dx = e.changedTouches[0].clientX - s; if (Math.abs(dx) > 50) (dx < 0 ? next() : prev()); touchStart.current = null;
//   };

//   if (!slides.length) return null;
//   const s = slides[idx] || {};

//   return (
//     <div className="lt-slidescope" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
//       <div className="lt-progress">{idx + 1} / {slides.length}</div>

//       {/* החץ "הבא" עבר לשמאל */}
//       <button className="lt-nav lt-nav-left" onClick={next} aria-label="הבא">
//        <svg width="28" height="28" viewBox="0 0 24 24"><path fill="currentColor" d="m14 7l-5 5l5 5V7Z"/></svg>
//       </button>
      
//       {/* החץ "הקודם" עבר לימין */}
//       <button className="lt-nav lt-nav-right" onClick={prev} disabled={idx === 0} aria-label="הקודם">
//        <svg width="28" height="28" viewBox="0 0 24 24"><path fill="currentColor" d="m10 17l5-5l-5-5v10Z"/></svg>
        
//       </button>

//       <div key={idx} className={`lt-frame ${dir === "right" ? "lt-enter-right" : "lt-enter-left"}`}>
//         {s.title && <h1 className="lt-title">{s.title}</h1>}
//         <div className="lt-grid">
//           {s.text &&  <div className="lt-text lt-textIn">{s.text.split('#').map((line, i) => (
//             <span key={i}>
//               {line}
//               {i < s.text.split('#').length - 1 && <br />}
//             </span>
//           ))}</div>}
//           {s.imageUrl && <div className="lt-imgwrap lt-imgIn"><img className="lt-img" src={s.imageUrl} alt={s.title||''}/></div>}
//         </div>

//         {idx === slides.length - 1 && (
//           <div style={{ textAlign:'center', marginTop: 16 }}>
//             <button className="lt-btn" onClick={onFinish}>מתחילים</button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }




import { useEffect, useRef, useState } from "react";

function getOptimizedImageUrl(url, maxWidth = 800) {
  if (!url || !url.includes('cloudinary.com')) {
    return url;
  }

  const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 800;
  const width = Math.min(screenWidth, maxWidth);
  const transformations = `w_${width},q_auto:good,f_auto,c_limit,dpr_auto`;

  const uploadIndex = url.indexOf('/upload/');
  if (uploadIndex === -1) {
    return url;
  }

  const beforeUpload = url.substring(0, uploadIndex + 8);
  const afterUpload = url.substring(uploadIndex + 8);

  return `${beforeUpload}${transformations}/${afterUpload}`;
}

export default function SlidesPager({ slides = [], onFinish }) {
  const [idx, setIdx] = useState(0);
  const [dir, setDir] = useState("right");
  const touchStart = useRef(null);

  const next = () => (idx < slides.length - 1 ? (setDir("right"), setIdx(i => i + 1)) : onFinish?.());
  const prev = () => (idx > 0 ? (setDir("left"), setIdx(i => i - 1)) : null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx, slides.length]);

  const onTouchStart = e => touchStart.current = e.changedTouches[0].clientX;
  const onTouchEnd = e => {
    const s = touchStart.current;
    if (s == null) return;
    const dx = e.changedTouches[0].clientX - s;
    if (Math.abs(dx) > 50) (dx < 0 ? next() : prev());
    touchStart.current = null;
  };

  if (!slides.length) return null;
  const s = slides[idx] || {};

  return (
    <div className="lt-slidescope" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <div className="lt-progress">{idx + 1} / {slides.length}</div>

      <button className="lt-nav lt-nav-left" onClick={next} aria-label="הבא">
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path fill="currentColor" d="m14 7l-5 5l5 5V7Z" />
        </svg>
      </button>

      <button className="lt-nav lt-nav-right" onClick={prev} disabled={idx === 0} aria-label="הקודם">
        <svg width="28" height="28" viewBox="0 0 24 24">
          <path fill="currentColor" d="m10 17l5-5l-5-5v10Z" />
        </svg>
      </button>

      <div key={idx} className={`lt-frame ${dir === "right" ? "lt-enter-right" : "lt-enter-left"}`}>
        {s.title && <h1 className="lt-title">{s.title}</h1>}
        <div className="lt-grid">
          {s.text && (
            <div className="lt-text lt-textIn">
              {s.text.split('#').map((line, i) => (
                <span key={i}>
                  {line}
                  {i < s.text.split('#').length - 1 && <br />}
                </span>
              ))}
            </div>
          )}
          {s.imageUrl && (
            <div className="lt-imgwrap lt-imgIn">
              <img
                className="lt-img"
                src={getOptimizedImageUrl(s.imageUrl)}
                alt={s.title || ''}
                loading="lazy"
              />
            </div>
          )}
        </div>

        {idx === slides.length - 1 && (
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <button className="lt-btn" onClick={onFinish}>מתחילים</button>
          </div>
        )}
      </div>
    </div>
  );
}
